module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS2.16bc8554.jpg";